var map = {
	"./product-1.jpg": "8ee8",
	"./product-2.jpg": "2b1f",
	"./product-3.jpg": "c32b",
	"./product-4.jpg": "6a97",
	"./product-5.jpg": "e199",
	"./product-6.jpg": "1db1",
	"./product-7.webp": "8876"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d5bb";